import React from 'react';
import { Phone, ArrowRight, Star } from 'lucide-react';

const WHITE_GLOW = { textShadow: '0 0 60px rgba(255,255,255,0.5), 0 4px 20px rgba(0,0,0,0.8)' };
const BIG_CLS = 'block text-5xl sm:text-7xl md:text-8xl lg:text-9xl xl:text-[10rem]';
const CTA_STYLE = { background: 'linear-gradient(135deg, #143160 0%, #1E4A86 100%)', boxShadow: '0 0 40px rgba(14,58,101,0.4), 0 8px 32px rgba(0,0,0,0.3)' };

const CallJessHeadline = () => (
  <div className="relative text-center lg:text-left mt-12">
    <div className="absolute -inset-8 bg-white/20 blur-3xl rounded-3xl"></div>
    <div className="relative" aria-label="Call Jess and forget the rest">
      <p className="font-serif font-black leading-[0.85] mb-2"><span className={`${BIG_CLS} text-white drop-shadow-2xl`} style={WHITE_GLOW}>CALL</span></p>
      <p className="font-serif font-black leading-[0.85] mb-2"><span className={`${BIG_CLS} gold-gradient-text shimmer`}>JESS</span></p>
      <p className="font-serif font-black leading-[0.85] mb-2"><span className="block text-4xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl gold-gradient-text shimmer" style={{ animationDelay: '0.3s' }}>& FORGET</span></p>
      <p className="font-serif font-black leading-[0.85]"><span className={`${BIG_CLS} text-white drop-shadow-2xl`} style={WHITE_GLOW}>THE REST!</span></p>
      <div className="flex items-center justify-center lg:justify-start space-x-2 sm:space-x-4 mt-6 sm:mt-8">
        <div className="flex space-x-0.5 sm:space-x-1">
          {[0, 1, 2, 3, 4].map((i) => <Star key={i} className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10 fill-gold-400 text-gold-400 drop-shadow-2xl animate-pulse" style={{ animationDelay: `${i * 0.1}s` }} />)}
        </div>
        <span className="text-base sm:text-xl lg:text-2xl font-black text-white drop-shadow-xl">5-STAR RATED</span>
      </div>
    </div>
  </div>
);

export const HeroCallBanner = () => (
  <>
    <CallJessHeadline />
    <p className="text-lg sm:text-2xl text-white leading-relaxed font-bold text-center lg:text-left drop-shadow-2xl">Virginia Beach | Outer Banks | Coastal VA &amp; NC | Military Relocation Specialist</p>
    <div className="space-y-4 w-full">
      <a href="tel:252-564-5612" className="block">
        <button className="w-full text-white shadow-2xl group border-2 border-gold-400/50 text-xl sm:text-2xl md:text-3xl px-6 sm:px-10 py-5 sm:py-6 font-black uppercase tracking-wide hover:scale-105 transition-all relative overflow-hidden rounded-md" style={CTA_STYLE}>
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent shimmer-bg"></div>
          <span className="relative flex items-center justify-center">
            <Phone className="w-6 h-6 sm:w-10 sm:h-10 mr-2 sm:mr-4 text-gold-400 animate-pulse" />
            252-564-5612
            <ArrowRight className="w-6 h-6 sm:w-10 sm:h-10 ml-2 sm:ml-4 text-gold-400 group-hover:translate-x-2 transition-transform" />
          </span>
        </button>
      </a>
      <p className="text-center text-lg text-white font-black drop-shadow-lg bg-gradient-to-r from-transparent via-black/40 to-transparent backdrop-blur-sm py-3 px-6 rounded-full border border-white/20">📞 CALL JESS - Available 7 Days a Week!</p>
    </div>
  </>
);
